export default "__VITE_ASSET__t73kGQuC__"